(() => {
  if (window.__btcBackToCreateBound) return;
  window.__btcBackToCreateBound = true;

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-btc-toggle]');
    if (toggle) {
      event.preventDefault();

      const selector = toggle.getAttribute('data-btc-toggle');
      if (!selector) return;

      const items = document.querySelectorAll(selector);
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';

      items.forEach((item) => {
        item.classList.toggle('btc-hidden', isOpen);
      });

      toggle.setAttribute('aria-expanded', String(!isOpen));
      toggle.textContent = isOpen
        ? (toggle.dataset.moreLabel || 'View More')
        : (toggle.dataset.lessLabel || 'Show Less');

      return;
    }

    const pairButton = event.target.closest('[data-btc-add-pair]');
    if (!pairButton) return;

    event.preventDefault();

    const ids = (pairButton.dataset.variantIds || '')
      .split(',')
      .map((id) => Number(id.trim()))
      .filter(Boolean);

    if (!ids.length) return;

    const original = pairButton.textContent;
    pairButton.disabled = true;
    pairButton.textContent = 'Adding…';

    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          items: ids.map((id) => ({id, quantity: 1}))
        })
      });

      if (!response.ok) throw new Error('Unable to add products');
      window.location.href = root + 'cart';
    } catch (error) {
      console.error(error);
      pairButton.disabled = false;
      pairButton.textContent = 'Please try again';

      setTimeout(() => {
        pairButton.textContent = original;
      }, 1800);
    }
  });
})();